import { inject, computed } from 'vue';
import { CloseEditDialog, IsActiveModuleEditDialog } from '@/injectionKeys';
import { useTemplateStore } from '@/store/template';
import { useDeviceInfoStore } from '@/store/deviceInfo';

// 아직 타입지정된 pops는 가져올 수 없음
// https://vuejs.org/guide/typescript/composition-api.html#typing-component-props
// export interface Props {
//   element:any,
//   depth:number,
//   layoutChecked:boolean,
// }
//
// export const commonProps = withDefaults(defineProps<Props>(),{
//   element: null,
//   depth:0,
//   layoutChecked : false,
// });

export const commonProps = {
  element: {
    required: true,
    type: Object,
    default: null,
  },
  depth: {
    // required: true,
    type: Number,
    default: 0,
  },
  layoutChecked: {
    // required: true,
    type: Boolean,
    default: false,
  },
  status: {
    type: String,
    default: 'live',
  },
  parentData: {
    required: true,
    type: Object,
    default: {},
  },
  settingData: {
    type: Object,
    default: {},
  },
};

export const device = computed(() => useDeviceInfoStore().$state.device);

export const useModule = (
  element: any,
  TemplateStore: ReturnType<typeof useTemplateStore>,
  schemaData: any,
  data: any,
  status: any
) => {
  const onCreate = () => {
    if (element.isNew) {
      TemplateStore.updateModules({ data: data, id: element.id });
    }
  };
  const openEditDialog: any = inject(IsActiveModuleEditDialog);
  const closeEditDialog = inject(CloseEditDialog);
  const onEdit = (data: any): void => {
    openEditDialog.id = element.id;
    openEditDialog.isActive = true;
    openEditDialog.schemaData = schemaData;
    openEditDialog.jsonData = data;
  };
  const onDelete = () => {
    TemplateStore.deleteModules({ id: element.id, status: status });
  };

  return {
    onCreate,
    onEdit,
    onDelete,
  };
};
